<template>
  <vb-modal
    v-if="show"
    :vb_options="{
      id: modal_id,
      visible: true,
      no_close_on_backdrop: true,
      no_close_on_esc: true,
      hide_header_close: true,
      hide_header: true,
      hide_footer: true,
      centered: true,
      size: 'lg',
    }"
  >
    <loader
      class="py-4 my-2"
      size="large"
      :show_timing_slot="true"
      :text_loading="messages"
      :text_footer="footer"
    />
  </vb-modal>
</template>

<script>
import { loading_messages } from '@/resources'

export default {
  name: 'loader-modal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    service: {
      type: String,
      default: '',
      validator: (v) => v === '' || v in loading_messages,
    },
  },
  computed: {
    modal_id() {
      return this.service ? `loader-modal:${this.service}` : 'loader-modal'
    },
    messages() {
      return this.service ? loading_messages[this.service].messages : undefined
    },
    footer() {
      return this.service ? loading_messages[this.service].footer : ''
    },
  },
}
</script>
